<template>
  <div class="id-validate data-validate">
    <div class="validate-top">
      <div class="top-left">
        <span class="title">{{$t('User.authentication')}}</span>
        <span
          :style="tagStyle"
          class="tag-box-id-validate"
        >{{tagText}}</span>
      </div>
      <div class="edit-btn">
        <i
          @click="editHandle"
          v-if="editFlag"
          class="iconfont icon-edit-21 pointer"></i>
      </div>
    </div>
    <el-row>
      <el-col
        :sm="12"
        :xs="24"
        class="left-box"
      >
        <div class="data-line">
          <span class="text-box">{{$t('User.name')}}: </span>
          <span class="data-box">{{allData.firstName}}{{allData.middlName}}{{allData.lastName}}</span>
        </div>
        <div class="data-line">
          <span class="text-box">{{$t('User.nationality')}}: </span>
          <span class="data-box">{{parseCountry(allData.nationality)}}</span>
        </div>
        <div class="data-line">
          <span class="text-box">{{$t('User.gender')}}: </span>
          <span class="data-box">{{getGender}}</span>
        </div>
        <div class="data-line">
          <span class="text-box">{{$t('User.birthday')}}: </span>
          <span class="data-box">{{allData.birthday}}</span>
        </div>
        <div class="data-line">
          <span class="text-box">{{$t('User.cardType')}}: </span>
          <span class="data-box">{{ idTypeText }}</span>
        </div>
        <div class="data-line">
          <span class="text-box">{{$t('User.certId')}}: </span>
          <span class="data-box">{{ allData.certId }}</span>
        </div>
<!--        -->
<!--        <div class="data-line">
          <span class="text-box">{{$t('ID_photo')}}: </span>
          <span
            class="data-box pointer file-down">
            <a :href="this.allData.certValidatedImgFrontUrl" :download="this.subsctringFileName(this.allData.certValidatedImgFrontUrl)" target="_blank">{{$t('Annex_1')}}</a>
          </span>
          <span
            v-if="secondImgFlag"
            class="data-box pointer file-down">
            <a :href="this.allData.certValidatedImgBackUrl" :download="this.subsctringFileName(this.allData.certValidatedImgBackUrl)" target="_blank">{{$t('Annex_2')}}</a>
          </span>
        </div>-->
      </el-col>
<!--      <el-col
        :sm="12"
        :xs="24"
        class="right-col"
      >
        <div class="data-line">
          <div class="text-box">{{$t('ID_photo')}}</div>
          <el-image
            class="id-img-el"
            :src="firstImgUrl"
            alt=""
            :preview-src-list="[firstImgUrl]"
          >
          </el-image>
          <el-image
            v-if="secondImgFlag"
            class="id-img-el"
            :src="secondImgUrl"
            alt=""
            :preview-src-list="[secondImgUrl]"
          >
          </el-image>
        </div>
      </el-col>-->
    </el-row>
    <personal-edit-dialog
      ref="editdialog"
      :dialog-show="dialogShow"
      :card-type-list="cardTypeList"
      @close="closeHandel"
      :all-data="allData"
      :get-gender="getGender"
      :parse-country="parseCountry(allData.nationality)"
      @ajax-success="editSuccess"
    ></personal-edit-dialog>
  </div>
</template>

<script>
import { downloadFile } from '@/utils/common'
import personalEditDialog from "@/components/myFiles/personalInfo/personalEditDialog";
import { colorRgba,subsctringFileName } from "@/utils";
import { countryList } from '@/assets/codelist/countryList';
export default {
  name: "idValidate",
  components:{
    personalEditDialog,
  },

  props: {
    allData: {
      type: Object,
      default(){
        return {
          identifyStatus: '',
          idType: '',
        }
      },
    },
    cardTypeList: {
      type: Array,
      default(){
        return [];
      }
    }
  },
  data() {
    return {
      yellowColor: '#F29132',
      greenColor: '#41B883',
      redColor: '#D85E5F',
      countryList:[],
      dialogShow: false,
    }
  },
  computed: {
    /*custStatus
      1, "注册未申请",
      2, "已申请未开户",
      3, "开户未入金",
      4, "入金未交易",
      5, "已交易",
      6, "销户",
      10, "注册未激活";*/

    /*  auditStatus:
    1, "客服审核",
    2, "交易部审核",
    3, "审核拒绝",
    4, "审核通过",
    5, "冻结",
    6, "销户",
    7, "账户信息复审";*/
    /*handleCertIdentifyStatus, 手持身份证验证
    1: 审核中
    2: 审核拒绝
    3: 审核通过
     */
    /*identifyStatus, 身份证照验证
    1: 审核中
    2: 审核拒绝
    3: 审核通过
     */
    tagText() {
      // 审核中, 审核通过, 审核拒绝
      let text = '';
      if(this.allData.identifyStatus == 2){
        text = this.$t('personInfoAuthFail');
      }else if(this.allData.identifyStatus == 3 ){
        text = this.$t('User.authPass');
      }else if(this.allData.handleCertIdentifyStatus == 1 ){
        text = this.$t('User.authing');
      } else {
        text = this.$t('User.authing');
      }
      return text;
    },
    secondImgFlag(){
      switch (this.allData.certType) {
        case 1:
        case 4:
        case 5:
          return true;
        case 2:
        case 3:
          return false;
      }
    },
    getGender(){
      if(this.allData.gender == 1){
        return this.$t('User.man');
      }else if(this.allData.gender == 2){
        return this.$t('User.women');
      }else {
        return ''
      }
    },
    editFlag(){
      if((this.allData.custStatus == 3 || this.allData.custStatus == 4 || this.allData.custStatus == 5) && (this.allData.identifyStatus == 2 || this.allData.handleCertIdentifyStatus == 2 )){
        return true;
      }else {
        return false;
      }
    },
    tagStyle(){
      if(this.allData.identifyStatus == 2){
        return {
          backgroundColor: colorRgba(this.redColor,.1),
          color: this.redColor,
        }
      }else if(this.allData.identifyStatus == 3){
        return {
          backgroundColor: colorRgba(this.greenColor,.1),
          color: this.greenColor,
        }
      }else if(this.allData.handleCertIdentifyStatus == 1){
        return {
          backgroundColor: colorRgba(this.yellowColor,.1),
          color: this.yellowColor,
        };
      }
    },
    idTypeText(){
      let lastText = '';
      if(!this.cardTypeList.length){
        lastText = '';
      }else {
        for (let i = 0; i <this.cardTypeList.length; i++) {
          if(this.allData.certType == this.cardTypeList[i].value){
            lastText = this.cardTypeList[i].label;
            break;
          }
        }
      }
      return lastText;
    },
    firstImgUrl(){
      // 身份证, 护照,驾驶本,户口本,居住证
      return this.allData.certValidatedImgFrontUrl;
    },
    secondImgUrl(){
      // 身份证, 护照,驾驶本,户口本,居住证
      return this.allData.certValidatedImgBackUrl;
    },
  },
  watch: {
    allData(allData, oldValue) {

    }
  },
  created() {
    this.countryList = countryList.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
  },
  methods: {
    subsctringFileName,
    idFrontHandle(){
      downloadFile(this.allData.certValidatedImgFrontUrl,subsctringFileName(this.allData.certValidatedImgFrontUrl));
    },
    idBackHandle(){
      downloadFile(this.allData.certValidatedImgFrontUrl,subsctringFileName(this.allData.certValidatedImgFrontUrl));
    },
    editHandle(){
      this.dialogShow = true;
    },
    // 国籍
    parseCountry(value){
      for(var i=0;i<this.countryList.length;i++){
        if(this.countryList[i].value ==value) {
          return this.countryList[i].label
        }
      }
    },
    closeHandel(){
      this.dialogShow = false;
    },
    editSuccess(){
      this.dialogShow = false;
      this.$emit('ajax-success');
    }
  },
}
</script>

<style lang="scss" scoped>
.id-validate {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 24px;
  .validate-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .top-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .tag-box-id-validate {
    display: inline-block;
    padding: 2px 5px;
    border-radius: 15px;
    margin-left: 10px;
  }
  .left-box {
    .data-line {
      margin-bottom: 10px;

      .text-box {
        text-align: right;
        color: #A29FAE;
        font-size: 14px;
      }
      .data-box {
        text-align: left;
        color: #5E5873;
        font-size: 14px;
      }
    }
  }
  .right-col {
    .data-line {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .text-box {
      margin-right: 15px;
      color: #A29FAE;
    }
    .id-img-el {
      width: 120px;
      height: 70px;
      margin-right: 10px;
    }
  }
  .file-down {
    display: inline-block;
    padding: 0 20px;
  }
}
</style>
